import React from 'react';
import PropTypes from 'prop-types';
import { useSegmentContext } from '../../../FlightsManager/Segment/SegmentManager/Context';
import { ConnectedSegmentArrival } from '../../../FlightsManager/Segment/SegmentArrival';
import { LegType } from '../../../../models';
import { ConnectedHotelSelectorDesktop } from '../../../HotelSelector';

const DestinationDesktop = ({ fieldFocused, onChangeFocus }) => {
    const { segment } = useSegmentContext();
    const { id } = segment;

    return (
        <ConnectedSegmentArrival segmentId={id}>
            {({ error, value, setValue }) => (
                <ConnectedHotelSelectorDesktop
                    validationError={error}
                    value={value}
                    setValue={setValue}
                    onChangeFocus={onChangeFocus}
                    focus={fieldFocused === LegType.ARRIVAL}
                />
            )}
        </ConnectedSegmentArrival>
    );
};

DestinationDesktop.propTypes = {
    fieldFocused: PropTypes.string,
    onChangeFocus: PropTypes.func.isRequired,
};

DestinationDesktop.defaultProps = {
    fieldFocused: null,
};

export default DestinationDesktop;
